module.exports = __webpack_public_path__ + "static/grill200-843797fed092d3a5f0b0146fd21d6b1f.png";